import { patch, post } from 'store/http/httpAction';
import { SET_FORMAT, SET_NAME, SET_REPORT_ID, RESET } from './actionTypes';

export const setName = value => ({
  type: SET_NAME,
  payload: { value }
});

export const setFormat = value => ({
  type: SET_FORMAT,
  payload: { value }
});

export const setReportId = value => ({
  type: SET_REPORT_ID,
  payload: { value }
});

export const reset = () => ({
  type: RESET,
});

export const trySaveNewReport = (reportFoldId, payload) => (
  dispatch,
  getState
) =>
  post(`/admin/report/report_folder/${reportFoldId}`, payload, dispatch).then(
    data => {
      dispatch(setReportId(data.data.id));
    }
  );

export const tryUpdateReport = (reportId, payload) => dispatch =>
  patch(`/admin/report/${reportId}`, payload, dispatch).then(data => {});



// WEBPACK FOOTER //
// ./src/views/ReportFilters/flow/actions.js